import subpageHeader from '@/components/app/header/subpage-header/subpage-header.vue'
import createUpdateCompetitionContent from '@/components/pages/page-templates/create-update-competition/create-update-competition-content/create-update-competition-content.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { isEmpty, find, cloneDeep } from 'lodash'

export default {
  components: {
    subpageHeader,
    createUpdateCompetitionContent
  },
  data() {
    return {
      users: [],
      competitionName: ''
    }
  },
  computed: {
    ...mapState('user', ['currentUser']),
    ...mapState('template', ['searchParams', 'currentTemplate', 'ageOptions']),
    ...mapState('competitionMechanic', ['mechanicList']),
    ...mapGetters('user', ['transformedUsersToPrivileges']),
    core: function () {
      if (!this.isEmpty(this.searchParams)) {
        return {
          age: find(this.ageOptions, (option) => option.name === this.currentTemplate.template.age).title,
          mechanic: find(this.mechanicList, (mechanic) => mechanic.id === this.currentTemplate.template.mechanic_id)
            .name,
          countries: !isEmpty(this.searchParams.country) ? [this.searchParams.country.name] : [],
          start_date: this.searchParams.start_date,
          end_date: moment(this.searchParams.start_date).add(1, 'days').format('YYYY-MM-DD').toString(),
          timezone: this.currentTemplate.template.default_timezone,
          archive_delay_months: this.currentTemplate.archive_delay_months,
          alternative_data_retention: false
        }
      } else {
        return {}
      }
    }
  },
  methods: {
    isEmpty,
    ...mapActions('user', ['getUsers']),
    ...mapActions('app', ['redirectTo']),
    ...mapActions('competition', ['createCompetition']),
    ...mapActions('competitionMechanic', ['getMechanicList']),
    onCreateCompetition: async function (data) {
      try {
        await this.createCompetition(data)
      } catch (e) {
        this.$notify({
          text: 'Error while creating competition',
          type: 'error'
        })
      }
    }
  },
  async created() {
    this.getMechanicList()
    await this.getUsers({
      sort_by: 'name',
      status: 'enabled'
    })

    this.users = cloneDeep(this.transformedUsersToPrivileges)
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/page-templates/create-update-competition/create-competition/create-competition.js